module.exports = __webpack_public_path__ + "img/freedom24-dark.58963e04.png";